import { StatementProps } from 'modules/clients/types/client.types';

export const FundDetailStatement = ({
  clientId,
  formValues,
  startDate,
  endDate
}: StatementProps) => {
  return <div>FundDetailStatement</div>;
};
